import styles from "./ForWhomSection.module.css";
import firstImage from "../../../../assets/images/pages/ParentsMarathon/section-4-hearts.png"

const CheckCircle = () => (
  <svg
    className={styles.listMarker}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="10" cy="10" r="9" fill="#FF9500" stroke="#FF9500" strokeWidth="2" />
    <path d="M6 10L9 13L14 7" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const LEFT_ITEMS = [
  "Ребёнку 1,5–4 года",
  "Ребёнок не говорит или говорит мало",
  "Вы не знаете, с чего начать",
] as const;

const RIGHT_ITEMS = [
  "Вы готовы уделить немного времени каждый день",
  "Вы хотите развивать речь естественно и с любовью",
] as const;

export const ForWhomSection = () => {
  return (
    <section className={styles.section} aria-label="Кому подойдёт марафон">
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.cardContent}>
            <h2 className={styles.title}>
              Кому подойдет марафон{" "}
              <span className={styles.emoji} aria-hidden="true">💡</span>
            </h2>

            <div className={styles.columns}>
              <ul className={styles.list}>
                {LEFT_ITEMS.map((item) => (
                  <li key={item} className={styles.listItem}>
                    <CheckCircle />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>

              <ul className={styles.list}>
                {RIGHT_ITEMS.map((item) => (
                  <li key={item} className={styles.listItem}>
                    <CheckCircle />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <img src={firstImage} alt="section-4-hearts" />
        </div>
      </div>
    </section>
  );
};